module.exports = __webpack_public_path__ + "df201d01beef1acf9b5e13f1ff875ab1.svg";